import React from "react";
import icon_back from "bodycodi/cmap/app/svg/icon_back.svg";
import icon_x_large from "bodycodi/cmap/app/svg/icon_x_large.svg";
import icon_question from "bodycodi/cmap/app/svg/icon_question.svg";
import icon_more from "bodycodi/cmap/app/svg/icon_more.svg";

interface PopupHeader {
  title: string;
  rightIconType: "info" | "more" | "close";
  onClickBack: () => void;
  onClickRightIcon: () => void;
}

function PopupHeader({ title, rightIconType, onClickBack, onClickRightIcon }: PopupHeader) {
  return (
    <header className="popup-header">
      <div onClick={onClickBack} className="left-icon">
        <img src={icon_back} />
      </div>
      <span>{title}</span>
      <div onClick={onClickRightIcon} className="right-icon">
        {rightIconType === "info" && <img src={icon_question} />}
        {rightIconType === "more" && <img src={icon_more} />}
        {rightIconType === "close" && <img src={icon_x_large} />}
      </div>
    </header>
  );
}

export default PopupHeader;
